import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, NgModel, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { PagerService } from '../../services/index';
import * as $ from 'jquery/dist/jquery.min.js';
import { debug } from 'util';
declare var jQuery: any;
declare var External: any;
//declare var $: any;
@Component({
	selector: 'app-survey-score',
	templateUrl: './survey-score.component.html',
	styleUrls: ['./survey-score.component.css']
})
export class SurveyScoreComponent implements OnInit {
	scoreForm;
	setting_id: any = null;
	worldViewQuestionForm;
	wazNextQuestionForm;
	criteriaOneForm;
	criteriaTwoForm;
	groupSettingForm;
	group_setting_id = null;
	question_id: any = null;
	censored_words: any = '';
	appPurchaseId: any;
	next_question_id: any = null;
	options: any = null;
	options_answer: any = [];
	//censored:any = '';
	constructor(private commonService: CommonService, private authService: AuthService,
		private router: Router, private validationService: ValidationService,
		private pagerService: PagerService) { }

	ngOnInit() {
		//this.commonService.setTitle();
		setTimeout(function () { External.ValidateNumber('app_purchase'); }, 0);
		$(".navbar-brand").text("Site Setting");
		//setTimeout(function(){ External.setToolTip(); },2000);
		this.commonService.process();
		this.scoreForm = new FormGroup({
			score: new FormControl("", Validators.compose([
				Validators.required
			])),

			world_score: new FormControl("", Validators.compose([
				Validators.required
			])),

			country_score: new FormControl("", Validators.compose([
				Validators.required
			])),
			city_score: new FormControl("", Validators.compose([
				Validators.required
			])),

			videoonuserquestion: new FormControl("", Validators.compose([
             Validators.required,
			])),
			videoonwazaskquestion: new FormControl("", Validators.compose([
				Validators.required,
			   ])),

			censored: new FormControl("", Validators.compose([
			]))
		});

		this.groupSettingForm = new FormGroup({
			max_number_of_group: new FormControl("", Validators.compose([
				Validators.required
			])),
			max_number_of_user: new FormControl("", Validators.compose([
				Validators.required
			])),
			max_number_of_survey: new FormControl("", Validators.compose([
				Validators.required
			])),
		});

		this.worldViewQuestionForm = new FormGroup({
			question: new FormControl("", Validators.compose([
				Validators.required
			]))
		});

		this.wazNextQuestionForm = new FormGroup({
			question: new FormControl("", Validators.compose([
				Validators.required
			])),
			option_1: new FormControl("", Validators.compose([
				Validators.required
			])),
			option_2: new FormControl("", Validators.compose([
				Validators.required
			])),
			option_3: new FormControl("", Validators.compose([
			])),
			option_4: new FormControl("", Validators.compose([
			]))
		});

		this.criteriaOneForm = new FormGroup({
			favCount: new FormControl("", Validators.compose([
				Validators.required
			])),
			packageName: new FormControl("", Validators.compose([
				Validators.required
			])),
			likeCount: new FormControl("", Validators.compose([
				Validators.required
			])),
			amount: new FormControl("", Validators.compose([
			]))
		});

		this.criteriaTwoForm = new FormGroup({
			favCount: new FormControl("", Validators.compose([
				Validators.required
			])),
			packageName: new FormControl("", Validators.compose([
				Validators.required
			])),
			likeCount: new FormControl("", Validators.compose([
				Validators.required
			])),
			amount: new FormControl("", Validators.compose([
			]))
		});

		this.getSettings();
		this.getWorldViewQuestion();
		this.getWorldNextQuestion();
		this.getGroupSetting();
	}

	// Get world view question
	getWorldViewQuestion = function () {
		this.authService.getWorldViewQuestion().subscribe(data => {
			if (data.success) {
				this.question_id = data.question._id;
				this.worldViewQuestionForm.controls['question'].setValue(data.question.world_view_question);
			}
		});
	}

	// Get group setting view question
	getGroupSetting = function () {
		this.authService.getGroupSettings().subscribe(data => {
			if (data.success) {
				this.group_setting_id = data.GroupSetting._id;
				this.groupSettingForm.controls['max_number_of_group'].setValue(data.GroupSetting.max_number_of_group);
				this.groupSettingForm.controls['max_number_of_user'].setValue(data.GroupSetting.max_number_of_user);
				this.groupSettingForm.controls['max_number_of_survey'].setValue(data.GroupSetting.max_number_of_survey);
			}
		});
	}

	getWorldNextQuestion = function () {
		this.authService.getWorldNextQuestion().subscribe(data => {
			if (data.success) {
				this.next_question_id = data.question._id;
				this.wazNextQuestionForm.controls['question'].setValue(data.question.question);
				this.options_answer = [];
				data.question.options.forEach((element, index) => {
					this.wazNextQuestionForm.controls['option_' + (index + 1)].setValue(element[0]);
					this.options_answer.push(element[1]);
				});
			}
		});
	}

	//get Settings
	getSettings() {
		        // debugger;;
		this.commonService.process();
		this.authService.getSettings().subscribe(data => {
			console.log(data)
			         //debugger;;
			if (data.success) {
				        //debugger;;
				this.scoreForm.controls['world_score'].setValue(data.settings[0] ? data.settings[0].world_score : '');
				this.scoreForm.controls['score'].setValue(data.settings[0] ? data.settings[0].score : '');
				this.scoreForm.controls['country_score'].setValue(data.settings[0] ? data.settings[0].country_score : '');
				this.scoreForm.controls['city_score'].setValue(data.settings[0] ? data.settings[0].city_score : '');
				this.scoreForm.controls['videoonuserquestion'].setValue(data.settings[0] ? data.settings[0].videoonuserquestion : '');
				this.scoreForm.controls['videoonwazaskquestion'].setValue(data.settings[0] ? data.settings[0].videoonwazaskquestion : '');
				this.censored_words = data.settings[0] ? data.settings[0].censored : '';
				this.setting_id = data.settings[0]._id;
				this.criteriaOneForm.controls['packageName'].setValue(data.settings[0].criteriaOne.planName);
				this.criteriaOneForm.controls['favCount'].setValue(data.settings[0].criteriaOne.favoriteCount);
				this.criteriaOneForm.controls['likeCount'].setValue(data.settings[0].criteriaOne.likeCount);
				this.criteriaOneForm.controls['amount'].setValue(data.settings[0].criteriaOne.amount);

				this.criteriaTwoForm.controls['packageName'].setValue(data.settings[0].criteriaTwo.planName);
				this.criteriaTwoForm.controls['favCount'].setValue(data.settings[0].criteriaTwo.favoriteCount);
				this.criteriaTwoForm.controls['likeCount'].setValue(data.settings[0].criteriaTwo.likeCount);
				this.criteriaTwoForm.controls['amount'].setValue(data.settings[0].criteriaTwo.amount);

				setTimeout(function () {
					External.LoadTagInput();
				}, 100);
			}

			else {
				jQuery.growl.error({ title: 'Error', message: data.error });
			}
			this.commonService.hideProcess();
		});
	}

	//Submit Settings
	onSubmit(scoreData) {
		debugger;
		if (this.scoreForm.valid) {
			scoreData.censored = $('.tags input.form-control').val();
			jQuery("button.btn_save_score").text('Saving...').attr('disabled', true);
			this.authService.manageSettings(scoreData, this.setting_id).subscribe(data => {
				debugger;
				if (data.success) {
					jQuery.growl.notice({ title: 'Success', message: data.message });
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				jQuery("button.btn_save_score").text('Save').attr('disabled', false);
			});
		}
		else
			this.validationService.validateAllFormFields(this.scoreForm);
	}

	// Set world view question
	submitWorldViewQuestion = function (btnName) {
		if (this.worldViewQuestionForm.valid) {
			let questionId;
			if (btnName == "add") {
				jQuery("button.btn_save_question").text('Saving...').attr('disabled', true);
				questionId = '';
			} else {
				questionId = this.question_id;
				console.log(this.question_id);
				jQuery("button.btn_update_question").text('Updating...').attr('disabled', true);
			}
			this.authService.saveWorldViewQuestion(this.worldViewQuestionForm.value, questionId).subscribe(data => {
				if (data.success) {
					this.getWorldViewQuestion();
					jQuery.growl.notice({ title: 'Success', message: data.message });
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				jQuery("button.btn_save_question").text('Post new Question').attr('disabled', false);
				jQuery("button.btn_update_question").text('Update the Question').attr('disabled', false);
			});
		}
		else {
			this.validationService.validateAllFormFields(this.worldViewQuestionForm);
		}
	}
	submitNextWorldQuestion = function (form) {
		if (this.wazNextQuestionForm.valid) {
			var objNextQuestion = {
				question: form.question,
				options: [
					[form.option_1, 0],
					[form.option_2, 0],
				]
			}
			if (form.option_3)
				objNextQuestion.options.push([form.option_3, 0]);
			if (form.option_4)
				objNextQuestion.options.push([form.option_4, 0]);

			jQuery("button.add_WAZ_next").text('Posting...').attr('disabled', true);
			this.authService.saveWorldNextQuestion(objNextQuestion, this.next_question_id).subscribe(data => {
				if (data.success) {
					this.getWorldNextQuestion();
					jQuery.growl.notice({ title: 'Success', message: data.message });
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				jQuery("button.add_WAZ_next").text('Post New Survey').attr('disabled', false);
			});
		}
		else {
			this.validationService.validateAllFormFields(this.wazNextQuestionForm);
		}
	}
	submitGroupSetting = function (submitForm) {
		        // debugger;;
		if (this.groupSettingForm.valid) {
			jQuery("button.btn_save_group_setting").text('Saving...').attr('disabled', true);
			this.authService.saveGroupSettings(this.group_setting_id,submitForm).subscribe(data => {
				if (data.success) {
					jQuery.growl.notice({ title: 'Success', message: data.message });
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				jQuery("button.btn_save_group_setting").text('Save').removeAttr('disabled');
			});
		}
		else {
			this.validationService.validateAllFormFields(this.groupSettingForm);
		}
	}

	submitCriteriaOneForm = function (form) {
		var data ={_id:this.setting_id,level:'One',favoriteCount:form.favCount,likeCount:form.likeCount,amount:form.amount,planName:form.packageName}
		if (this.criteriaOneForm.valid) {
			jQuery("button.add_criteriaOne").text('Saving...').attr('disabled', true);
			this.authService.updateCriteria(data).subscribe(data => {
				if (data.success) {
					jQuery.growl.notice({ title: 'Success', message: data.message });
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				jQuery("button.add_criteriaOne").text('Save').removeAttr('disabled');
			});
		}
		else {
			this.validationService.validateAllFormFields(this.criteriaOneForm);
		}

	}

	submitCriteriaTwoForm = function (form) {
		var data ={_id:this.setting_id,level:'Two',favoriteCount:form.favCount,likeCount:form.likeCount,amount:form.amount,planName:form.packageName}
		if (this.criteriaTwoForm.valid) {
			jQuery("button.add_criteriaTwo").text('Saving...').attr('disabled', true);
			this.authService.updateCriteria(data).subscribe(data => {
				if (data.success) {
					jQuery.growl.notice({ title: 'Success', message: data.message });
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				jQuery("button.add_criteriaTwo").text('Save').removeAttr('disabled');
			});
		}
		else {
			this.validationService.validateAllFormFields(this.criteriaOneForm);
		}

	}
}



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/survey-score/survey-score.component.ts